import moment from "moment";

export const BonusHeaders = [
  { label: "Date", key: "timestamp" },
  { label: "Campaign", key: "campaign" },
  { label: "Type", key: "type" },
  { label: "Driver Name", key: "driverName" },
  { label: "Metro", key: "metro" },
  { label: "Amount", key: "amount" },
  { label: "Status", key: "status" },
  { label: "Reason", key: "statusCode" },
];

export function formatBonusTransactions(data) {
  const formattedData = data.map((item) => {
    const {
      campaign,
      driverName,
      metro,
      amount,
      status,
      statusCode,
      timestamp,
    } = item || {};

    return {
      campaign: `${campaign?.name || "-"}`,
      type: `${campaign?.type || "-"}`,
      driverName: `${driverName || "-"}`,
      metro: `${metro || "-"}`,
      amount: `${amount ? amount.toFixed(2) : "-"}`,
      status: `${status || "-"}`,
      statusCode: `${statusCode || "-"
        }`,
      timestamp: moment(timestamp).format('MM-DD-YYYY hh:mm A'),
    };
  }) || [];

  return formattedData;
}